import React from "react";

const FireSvg = ({width = '40px'}) => (
    <svg width={width} height={width} viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
         className="iconify iconify--noto">
        <radialGradient id="fire_a" cx="68.884" cy="124.296" r="70.587"
                        gradientTransform="rotate(-179.751 65.907 -39.816)scale(1 -1.64082)"
                        gradientUnits="userSpaceOnUse">
            <stop offset=".314" stop-color="#ff9800"/>
            <stop offset=".662" stop-color="#ff6d00"/>
            <stop offset=".972" stop-color="#f44336"/>
        </radialGradient>
        <path
            d="M35.56 40.73c-.57 6.08-.97 16.84 2.62 21.42 0 0-1.69-11.82 13.46-26.65 6.1-5.97 7.51-14.09 5.38-20.18-1.21-3.45-3.42-6.3-5.34-8.29-1.12-1.17-.26-3.1 1.37-3.03 9.86.44 25.84 3.18 32.63 20.22 2.98 7.48 3.2 15.21 1.78 23.07-.9 5.02-4.1 16.18 3.2 17.55 5.21.98 7.73-3.16 8.86-6.14.47-1.24 2.1-1.55 2.98-.56 8.8 10.01 9.55 21.8 7.73 31.95-3.52 19.62-23.39 33.9-43.13 33.9-24.66 0-44.29-14.11-49.38-39.65-2.05-10.31-1.01-30.71 14.89-45.11 1.18-1.08 3.11-.12 2.95 1.5"
            fill="url(#fire_a)"/>
        <radialGradient id="fire_b" cx="64.921" cy="54.062" r="73.86"
                        gradientTransform="rotate(90.579 18.654 7.312)scale(1 -.7525)" gradientUnits="userSpaceOnUse">
            <stop offset=".214" stop-color="#fff176"/>
            <stop offset=".328" stop-color="#fff27d"/>
            <stop offset=".487" stop-color="#fff48f"/>
            <stop offset=".672" stop-color="#fff7ad"/>
            <stop offset=".793" stop-color="#fff9c4"/>
            <stop offset=".822" stop-color="#fff8bd" stop-opacity=".804"/>
            <stop offset=".863" stop-color="#fff6ab" stop-opacity=".529"/>
            <stop offset=".91" stop-color="#fff38d" stop-opacity=".209"/>
            <stop offset=".941" stop-color="#fff176" stop-opacity="0"/>
        </radialGradient>
        <path
            d="M76.11 77.42c-9.09-11.7-5.02-25.05-2.79-30.37.3-.7-.5-1.36-1.13-.93-3.91 2.66-11.92 8.92-15.65 17.73-5.05 11.91-4.69 17.74-1.7 24.86 1.8 4.29-.29 5.2-1.34 5.36-1.02.16-1.96-.52-2.71-1.23a16.1 16.1 0 0 1-4.44-7.6c-.16-.62-.97-.79-1.34-.28-2.8 3.87-4.25 10.08-4.32 14.47C40.47 113 51.68 124 65.24 124c17.09 0 29.54-18.9 19.72-34.7-2.85-4.6-5.53-7.61-8.85-11.88"
            fill="url(#fire_b)"/>
    </svg>

);

export default FireSvg;